// extracted by mini-css-extract-plugin
export var divider = "_qo-0";
export var systemMessage = "_qo-1";
export var systemMessageWrapper = "_qo-2";